<div class="gu-confirm-overlay" *ngIf="notificacionActivada && display === 'block'">
  <div class="gu-confirm gu-confirm--download" role="dialog" aria-modal="true" aria-labelledby="comunicacionDetallesTitle">
    <div class="gu-confirm__icon gu-confirm__icon--download">
      <svg class="gu-confirm__circle" width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <circle cx="50" cy="50" r="50" fill="currentColor"/>
      </svg>
      <img src="assets/icons/download_24dp.svg" class="gu-confirm__glyph" alt="" aria-hidden="true">
    </div>
    <h3 class="gu-confirm__title" id="comunicacionDetallesTitle">{{ 'NOTIFICATION.DETAIL.DOWNLOAD_TITLE' | translate }}</h3>
    <div class="gu-confirm__details">
      <div><strong>{{ 'NOTIFICATION.DETAIL.IDENTIFIER' | translate }}:</strong> {{notificacionActivada.titular.identificador}}</div>
      <div><strong>{{ 'NOTIFICATION.DETAIL.ISSUER' | translate }}:</strong> {{notificacionActivada.titular.referenciaEmisor}}</div>
      <div><strong>{{ 'NOTIFICATION.DETAIL.DATE' | translate }}:</strong> {{formatDate(notificacionActivada.titular.fechaPuestaDisposicion)}}</div>
      <div><strong>{{ 'NOTIFICATION.DETAIL.CONCEPT' | translate }}:</strong> {{notificacionActivada.titular.remesa.concepto}}</div>
      <div><strong>{{ 'NOTIFICATION.DETAIL.DESCRIPTION' | translate }}:</strong> {{notificacionActivada.titular.remesa.descripcion}}</div>
    </div>
    <div class="gu-confirm__actions">
      <button type="button" class="gu-btn gu-btn--ghost" (click)="close()">
        {{ 'NOTIFICATION.BUTTON.CANCEL' | translate }}
      </button>
      <button [disabled]="loading" *ngIf="notificacionActivada.titular.remesa.justificante" type="button" class="gu-btn gu-btn--primary" (click)="downloadArchivo(notificacionActivada.titular.remesa.justificante)">
        {{ 'NOTIFICATION.DETAIL.DOWNLOAD_JUSTIFICANTE' | translate }}
      </button>
      <!-- Documento personalizado del destinatario (generado/firmado o adjunto). -->
      <button [disabled]="loading" *ngIf="notificacionActivada.titular.documento" type="button" class="gu-btn gu-btn--primary" (click)="downloadArchivo(notificacionActivada.titular.documento)">
        {{ 'NOTIFICATION.DETAIL.DOWNLOAD_DOC' | translate }}
      </button>
      <!-- Fallback legacy: documento común de la remesa, solo si no hay documento por destinatario. -->
      <button [disabled]="loading" *ngIf="!notificacionActivada.titular.documento && notificacionActivada.titular.remesa.contenido" type="button" class="gu-btn gu-btn--primary" (click)="downloadArchivo(notificacionActivada.titular.remesa.contenido)">
        {{ 'NOTIFICATION.DETAIL.DOWNLOAD_DOCS' | translate }}
      </button>
    </div>
  </div>
</div>
